import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyTruelarkLeafCropped = lazy(() => import('./svg-components/truelark-leaf-cropped'));

const TruelarkLeafCropped = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyTruelarkLeafCropped {...rest} />
  </Suspense>
);

export default TruelarkLeafCropped;
